import { useCallback } from 'react';
import { useTranslation } from '@frontend/i18n';
import { useAlert } from '@frontend/design-system';
import { useCollectPaymentMultiContext } from '../../../../collect-payment-multi.context';
import { PAYMENT_MULTI_STEPS } from '../../../../utils/steps';
import { CareCreditCollectStepNavigationProps } from '../care-credit-collect.types';

export const CareCreditCollectGenericNavigation = ({ body: Body }: CareCreditCollectStepNavigationProps) => {
  const {
    multiStep: { goPrevStep, onCancel, goNextStep, onComplete },
    setCareCreditEnrollmentStatus,
    setCareCreditMessageType,
  } = useCollectPaymentMultiContext();

  const alert = useAlert();
  const { t } = useTranslation('payments');

  const onGoBack = useCallback(() => {
    goPrevStep({
      orStep: PAYMENT_MULTI_STEPS.paymentMethods,
    });
  }, [goPrevStep]);

  const onSubmissionAccepted = useCallback(() => {
    alert.success(t('CareCredit transaction approved. Printing receipt now.'));
    onComplete();
  }, [onComplete]);

  const onSubmissionDeclined = useCallback(() => {
    goPrevStep({
      orStep: PAYMENT_MULTI_STEPS.paymentMethods,
    });
    setCareCreditEnrollmentStatus({
      status: 'declined',
      message: t('CareCredit transaction declined. Please select another collection method.'),
    });
  }, [goPrevStep]);

  const onGoToMessageStep = useCallback(() => {
    setCareCreditMessageType('payment-link');
    goNextStep({
      orStep: PAYMENT_MULTI_STEPS.careCreditMessageDisclosure,
    });
  }, [goNextStep]);

  return (
    <Body
      onGoBack={onGoBack}
      onCancel={onCancel}
      onSubmissionAccepted={onSubmissionAccepted}
      onSubmissionDeclined={onSubmissionDeclined}
      onGoToMessageStep={onGoToMessageStep}
    />
  );
};
